import tacHelpers from '../../../state/tac/tacHelpers';
import { translate } from '../../L10n';
import { t } from '../../../translations';
import productService from '../../products';
import { isStandAlone } from '../../products/models';
import { hasRoomSlots } from '../common';
import { selectTac, selectTacIsEmpty } from '../../../state/tac/tacSelectors';
import { actionShowSceneSheet } from '../../../state/scene';
import {
  selectAvailableElvarliVariants,
  selectHasPostsAndSections,
} from '../../products/elvarli';
import {
  ELVARLI_VARIANT,
  SELECT_ELVARLI_VARIANT,
} from '../../../components/Sheets/SelectElvarliVariantSheet/SelectElvarliVariantSheet';
import { actionSetRangeData } from '../../../state/rangeData/rangeDataActions';
import { State } from '../../../state/StateTypes';
import { Thunk } from '../../../generalTypes';
import {
  selectCurrentFilterName,
  selectFilterText,
} from '../../../state/productMenu/productMenuSelectors';
import { FILTERS, ITEMS } from '../../../constants';
import { thunkConditionalDisplayIntroPopups } from '../../../state/popups/popupsThunks';
import { thunkRemoveUnwantedSectionSubFilterOptions } from '../../scene/elvarli';
import { selectRangeDataSlice } from '../../../state/rangeData/rangeDataSelectors';
import store from '../../../state';
import {
  selectIsMobile,
  selectIsTablet,
} from '../../../state/userAgent/userAgentSelectors';
import localStatisticsReporter from '../../statistics/insights/custom/local/localStatisticsReporter';
import CeilingInput from '../../../components/Input/LabeledUnitInput';

function getDisabledStatus(tac: any, product: any, space: any, rebased: any) {
  if (isStandAlone(product)) {
    if (
      !hasRoomSlots(tac, space, product) &&
      !tacHelpers.hasOpenSlot(tac, product, rebased)
    ) {
      return translate(t.BALLOON_HINT_NO_PLACE);
    }
  } else {
    if (!tacHelpers.hasOpenSlot(tac, product, rebased)) {
      return translate(t.BALLOON_HINT_NO_PLACE);
    }
  }

  return false;
}

const handleLackOfElvarliVariant: Thunk = () => (dispatch, getState) => {
  const state = getState();
  const [elvarliVariant] = selectAvailableElvarliVariants(state);
  localStatisticsReporter.reportSubPlannerAutomaticChoice(elvarliVariant);
  dispatch(actionSetRangeData(ELVARLI_VARIANT, elvarliVariant));
};

function shouldDisplayProductType(product: any) {
  return !productService.isSection(product);
}

export const selectSelectedElvarliVariant = (state: State) =>
  selectRangeDataSlice(ELVARLI_VARIANT)(state);

export const selectCurrentlyUsedElvarliVariant = (state: State) =>
  // @ts-ignore
  selectTac(state).items[0].filter.type;

const thunkUseSceneSheet: Thunk = () => (dispatch, getState) => {
  const state = getState();
  const tacIsEmpty = selectTacIsEmpty(state);
  const hasBothSectionTypes = selectHasPostsAndSections(getState());

  if (tacIsEmpty && hasBothSectionTypes)
    return dispatch(actionShowSceneSheet(SELECT_ELVARLI_VARIANT));

  if (!hasBothSectionTypes) dispatch(handleLackOfElvarliVariant());

  if (!tacIsEmpty) {
    const currentVariant = selectCurrentlyUsedElvarliVariant(state);
    localStatisticsReporter.reportSubPlannerAutomaticChoice(currentVariant);
    dispatch(actionSetRangeData(ELVARLI_VARIANT, currentVariant));
  }

  dispatch(thunkConditionalDisplayIntroPopups());
  dispatch(thunkRemoveUnwantedSectionSubFilterOptions());
};

const getSceneInitFunctions = () => [thunkUseSceneSheet];

/**
 * Returns filter object for sub filter
 */
export const getCeilingHeightInputObject = (
  conditionExtension: any = () => true
) => ({
  Component: CeilingInput,
  appliesToFilter: FILTERS.SECTIONS,
  condition: () => {
    const state = store.getState();
    const variant = selectRangeDataSlice(ELVARLI_VARIANT)(state);
    const isMobile = selectIsMobile(state);
    const isTablet = selectIsTablet(state);

    return variant === ITEMS.SECTION_POSTS && !isMobile && !isTablet;
  },
});

const getSwiperConfigSectionItems = () => [getCeilingHeightInputObject()];

const getSwiperFilterText = (state: State) => {
  const variant = selectRangeDataSlice(ELVARLI_VARIANT)(store.getState());

  const handleSection = () => {
    const text = selectFilterText(state)?.[variant];

    return text ? text : null;
  };

  const handleParts = () => {
    return variant === ITEMS.SECTION_POSTS
      ? selectFilterText(state).brackets
      : null;
  };

  return selectCurrentFilterName(state) === FILTERS.SECTIONS
    ? handleSection()
    : handleParts();
};

export { getDisabledStatus };

export default {
  getDisabledStatus,
  shouldDisplayProductType,
  getSceneInitFunctions,
  getSwiperConfigSectionItems,
  getSwiperFilterText,
};
